import styles from "./collection-progress.module.css";

export const CollectionProgress = ({
    progress,
}: {
    progress: {max: number; value: number};
}) => {
    const {max, value} = progress;
    const completeClassName =
        value >= max ? ` ${styles.fillingProgressComplete}` : "";
    return (
        <progress
            value={value}
            max={max}
            className={`${styles.fillingProgress}${completeClassName}`}
        >
            {`${value} / ${max}`}
        </progress>
    );
};
